import { trackClientEvent } from '../../../../trackClientEvent';
export var eventKey = 'pricing-opening_order_incentives_view_offer_banner-view';
/**
 * Track when retailer views the Offer Banner for Opening Order Incentives
 */ export function trackPricingOpeningOrderIncentivesViewOfferBannerView() {
    return trackClientEvent({
        eventKey: eventKey,
        realTimeTracking: true
    });
}
